<template>
  <div class="chat">
    <df-messenger chat-title="Veximus AI" chat-icon="images/ui/robot.svg" agent-id="899f06d7-3ec9-42e9-a5e5-461c766b9f06" language-code="en" df-cx="true" v-pre />
  </div>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.chat {
  position: absolute;
  z-index: 1100;

  df-messenger {
    --df-messenger-bot-message: #fff;
    --df-messenger-button-titlebar-color: #0d6efd;
    --df-messenger-chat-background-color: #fbfbfb;
    --df-messenger-font-color: #333;
    --df-messenger-input-placeholder-font-color: #ccc;
    --df-messenger-send-icon: #0d6efd;
    --df-messenger-user-message: #dcf8c6;
  }
}
</style>

<script>
export default {
  methods: {
    initMessenger: function (e) {
      var messenger = document.querySelector('df-messenger');

      // Events
      messenger.addEventListener('df-response-received', function (e) {
        console.log(e);
      });

      // Initializations
      messenger.renderCustomText("👋 Hi, there! Welcome to Veximus Technologies. I'm here to help you find your way.");
      messenger.renderCustomText('What do you like to know about?');
      messenger.renderCustomCard([
        {
          type: 'chips',
          options: [
            {
              text: 'Our Services'
            },
            {
              text: 'Our Pricings'
            },
            {
              text: 'Report Problem'
            },
            {
              text: 'Server Status'
            }
          ]
        }
      ]);
    }
  },

  watch: {
    '$i18n.global.locale.value'(currentLocale, previousLocale) {
      console.log(currentLocale);
    }
  },

  created() {
    window.addEventListener('dfMessengerLoaded', this.initMessenger);
  },

  beforeUnmount() {
    window.removeEventListener('dfMessengerLoaded', this.initMessenger);
  },

  mounted() {
    let dialogflowScript = document.createElement('script');
    dialogflowScript.setAttribute('src', 'https://www.gstatic.com/dialogflow-console/fast/messenger-cx/bootstrap.js?v=1');
    document.head.appendChild(dialogflowScript);
  }
};
</script>
